import { getKeys } from "@base/util/TypeUtil";
import { appTemplates } from "@biz/definitions/ArticleShopTemplates";
import { LoungeData } from "@biz/definitions/LoungeData";
import { sojoInfos, SojoWoodType } from "@biz/definitions/LoungeDefinitions";
import { ModelData } from "@biz/definitions/ModelDefinitions";
import { IModelProductData } from "@biz/definitions/ModelProductDefinitions";
import { CalcProductLogic } from "@biz/items/CalcProductLogic";
import { FieldErrorMap } from "@biz/models/FieldErrorMap";
import { PartListPriority, ShoppingCartPriority } from "@biz/models/ShoppingListDefinitions";
import { PD } from "@biz/PD";
import { ICalcContext, ICalculatedProductResult } from "@biz/projectCalculation/ProjectDefinitions";

export class CalcModelProduct3dLogic {
  static calc3d(product: IModelProductData, slc: ICalcContext): ICalculatedProductResult {

    switch (product.templateId) {
      case "beanbag": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcBeanbagArticleNumber(product), {
          features: { colorId, logo: ModelData.getLogo(product) },
          featureTemplate: appTemplates.loungeWithLogo,
          offerList: "H",
        });
        break;
      }
      case "drop": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcDropArticleNumber(product), {
          features: { colorId },
          featureTemplate: appTemplates.lounge,
          offerList: "H",
        });
        break;
      }
      case "cat": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcCatArticleNumber(product), {
          features: { colorId },
          featureTemplate: appTemplates.lounge,
          offerList: "H",
        });
        break;
      }
      case "chillout": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcChilloutArticleNumber(product), {
          features: { colorId, logo: ModelData.getLogo(product) },
          featureTemplate: appTemplates.loungeWithLogo,
          offerList: "H",
        });
        break;
      }
      case "pillow_40x40":
      case "pillow_40x80":
      case "pillow_75x75": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcPillowArticleNumber(product), {
          features: { colorId, logo: ModelData.getLogo(product) },
          featureTemplate: appTemplates.lounge,
          offerList: "H",
        });
        break;
      }
      case "stool": {
        const colorId = product.configuration?.colorId || "";
        CalcProductLogic.addRuleArticle(slc, LoungeData.calcStoolArticleNumber(product), {
          features: { colorId, logo: ModelData.getLogo(product) },
          featureTemplate: appTemplates.loungeWithLogo,
          offerList: "H",
        });
        break;
      }
      case "sojo_sunbed":
      case "sojo_sunbed_small":
      case "sojo_sunseat": {
        const colorId = product.configuration?.colorId || "";
        const sojoWoodType: SojoWoodType = "FA001" // Eiche natur;

        CalcProductLogic.addRuleArticle(slc, LoungeData.calcSojoHardwareArticleNumber(product), {
          features: { colorId, sojoWoodType },
          featureTemplate: appTemplates.sojoHW,
          offerList: "H",
          partList: { priority: PartListPriority.SojoHW },
          shoppingCartPriority: ShoppingCartPriority.SojoHW,
        });

        CalcProductLogic.addRuleArticle(slc, LoungeData.calcSojoClothArticleNumber(product),
          {
            features: { colorId },
            featureTemplate: appTemplates.sojoCloth,
            offerList: "H",
            partList: { list: "stockList", priority: PartListPriority.SojoCloth },
            shoppingCartPriority: ShoppingCartPriority.SojoCloth,
          }
        );

        const slots = product.configuration.sojoSlot || {};
        for (const k of getKeys(slots)) {
          const slot = slots[k];
          if (slot?.type === "sojo_table") {
            CalcProductLogic.addRuleArticle(slc, "6M09790", {
              features: { sojoWoodType },
              featureTemplate: appTemplates.sojoHW,
              offerList: "H",
            });
          }
        }

        if (slots.left?.type === "sojo_table" || slots.right?.type === "sojo_table") {
          CalcProductLogic.addRuleArticle(slc, "6M09791", {
            features: { sojoWoodType },
            featureTemplate: appTemplates.sojoHW,
            offerList: "H",
          });
        }

        CalcProductLogic.addRuleArticle(slc, sojoInfos[product.templateId].rainSleeve, {
          count: 1,
          articleType: "optional"
        });

        break;
      }
      default:
        throw new Error("ModelProduct not handled so far: " + product.templateId)
    }

    CalcProductLogic.finalizeCalcContext(slc, { incomplete: !product, defaultOfferList: "H", count: product.count === undefined ? 1 : product.count });

    return {
      id: product.id,
      pd: PD.productToPD(product),
      infos: slc.infos,
      errors: slc.errors,
      errorMap: FieldErrorMap.errorMapFromErrors(slc.errors || []),
      articles: slc.ruleArticles,
      // modified: product,
      product,
      // modifiedSunSail: sunSail,
    };
  }
}